<template>
    <div class="content">
        <div class="md-layout">
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                <md-card>
                    <md-card-header data-background-color="primary">
                        <div class="flex-container">
                            <h4 class="title">Support</h4>
                        </div>
                    </md-card-header>
                    <md-card-content>
                        <md-table table-header-color="primary">
                            <md-table-row>
                                <md-table-head>Name</md-table-head>
                                <md-table-head>Issue</md-table-head>
                                <md-table-head>Date</md-table-head>
                                <md-table-head>Time</md-table-head>
                                <md-table-head>Check</md-table-head>
                                <md-table-head></md-table-head>
                            </md-table-row>
                            <md-progress-spinner v-if="loading" md-mode="indeterminate" class="center"></md-progress-spinner>
                            <md-table-row v-for="(worklog, index) in worklogs" v-bind:key="worklog.tempoWorklogId">
                                <md-table-cell>{{ worklog.issue.project.name }}</md-table-cell>
                                <md-table-cell>
                                    <h4><a target="_blank" :href="'https://newance.atlassian.net/browse/' + worklog.issue.key" >{{ worklog.issue.name }}</a></h4>
                                    <p v-if="editIndex != index">{{ worklog.description }}</p>
                                    <form v-if="editIndex == index">
                                        <md-field>
                                            <label>Description</label>
                                            <md-textarea v-model="form.description" type="text"></md-textarea>
                                        </md-field>
                                        <md-button type="submit" class="md-primary" :disabled="sending" @click.prevent="submit">Update description</md-button>
                                        <md-progress-spinner v-if="sending" class="md-primary loading" :md-diameter="41" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
                                    </form>
                                </md-table-cell>
                                <md-table-cell>{{ new Date(worklog.date).getDate() + '/' +  (new Date(worklog.date).getMonth() + 1) + '/' + new Date(worklog.date).getFullYear()}}</md-table-cell>
                                <md-table-cell>{{ toHours(worklog.time_spend / 3600) }}</md-table-cell>
                                <md-table-cell><md-icon v-if="worklog.to_check" class="md-primary">check_circle_outline</md-icon></md-table-cell>
                                <md-table-cell>
                                    <md-button @click="toggleEdit(index)" class="md-icon-button md-dense md-raised md-primary">
                                        <md-icon>edit</md-icon>
                                    </md-button>
                                </md-table-cell>
                            </md-table-row>

                            <md-table-row v-if="!loading">
                                <md-table-cell></md-table-cell>
                                <md-table-cell></md-table-cell>
                                <md-table-cell></md-table-cell>
                                <md-table-cell class="md-body-2">{{ toHours(totalHours) }}</md-table-cell>
                                <md-table-cell></md-table-cell>
                                <md-table-cell></md-table-cell>
                            </md-table-row>
                        </md-table>
                    </md-card-content>
                </md-card>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import axios from "@/axios";
import utils from "@/utils.js";

export default {
    name: "support",
    mixins: [utils],
    data() {
        return {
            loading: false,
            worklogs: [],
            editIndex: null,
            sending: false,
            form: {
                description: null,
            }
        }
    },
    methods: {
        fetch() {
            this.loading = true;
            axios.get("/support")
                .then(e => {
                    this.worklogs = e.data.worklogs;
                    this.loading = false;
                });
        },
        toggleEdit(index) {
            if(this.editIndex == index) {
                this.editIndex = null;
            }else{
                this.form.description = this.worklogs[index].description;
                this.editIndex = index;
            }
        },
        submit() {
            let worklog = this.worklogs[this.editIndex]
            worklog.description = this.form.description;

            this.editIndex = null;
            
            this.sending = true;
            axios
                .put('/support/' + worklog.id, worklog)
                .then(response => {
                    this.sending = false;
                });
        }
    },
    computed: {
        totalHours(){
            let total = 0;

            this.worklogs.forEach(worklog => {
                total += worklog.time_spend;
            });

            return total / 3600;
        }
    },
    mounted() {
        this.fetch();
    }
};
</script>

<style scoped>
.loading{
    margin: 10px 20px;
}
</style>
